<template>
  <div class="scores">
    <button v-if="!open" title="Ajouter un nouveau score" @click="newScore">
      <i class="el-icon-circle-plus-outline" />
    </button>
    <select class="types" v-if="open" @blur="open = false" @change="newScoreList">
      <option>Select a new type</option>
      <option disabled>---</option>
      <option v-for="item in scoreTypes" :key="item.id" :title="item.name" :data-main="item.main" :data-id="item.id">
        {{ item.name }}
      </option>
    </select>
    <button title="Fermer la liste" @click="open = false" v-if="open">
      <i class="el-icon-close" />
    </button>
    <div class="list">
      <score v-for="item in scores" :key="item.id" :scoreTypes="scoreTypes" :score="item"/>
    </div>
  </div>
</template>

<script>
import Score from '@/components/sport/games/Score'

export default {
  name: 'SportScore',
  components: { Score },
  props: {
    scoreTypes: Array,
    competitorId: Number,
    competitorPersonId: Number
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    scores () {
      if (this.competitorPersonId) {
        return this.$store.getters['Sport/Score/getByCompetitorPerson'](this.competitorPersonId)
      } else {
        return this.$store.getters['Sport/Score/getByCompetitor'](this.competitorId)
      }
    }
  },
  methods: {
    newScoreList (event) {
      const select = event.target
      const value = select.options[select.selectedIndex].getAttribute('data-id')
      console.log(select.selectedIndex, value)
      this.saveScore(value)
      // this.open = false
    },
    newScore () {
      if (this.scoreTypes.length === 1) {
        this.saveScore(this.scoreTypes[0].id)
      } else {
        this.open = true
      }
    },
    saveScore (scoreTypeId) {
      const parameters = { typeId: scoreTypeId }
      if (this.competitorPersonId) {
        parameters.competitorPersonId = this.competitorPersonId
      } else {
        parameters.competitorId = this.competitorId
      }
      this.$store.dispatch('Sport/Score/post', parameters)
    }
  }
}
</script>

<style scoped>
  .scores{
    display:flex;
    flex:1 1 auto;
    flex-direction:row;
    background-color:var(--color-primary);
    padding:5px;
    margin-left:10px;
    border-radius:4px;
    gap:5px
  }
  .scores > button{
    border-style:none;
    background-color:transparent;
    padding:0;
    margin-right:5px
  }
  .scores > .list{
    display:flex;
    flex-direction:column;
    justify-content:center
  }
  .scores > .types{
    align-self:center
  }
  .scores > .types > option[data-main="true"]{
    font-weight:bold;
    color:green
  }
  .scores > .types > option[data-main="false"]{
    font-weight:bold;
    color:blue
  }
</style>
